import moment from 'jalali-moment';

export function getPersianDateTime(
  isoDateString: string | undefined,
): string | null {
  if (!isoDateString) return null;
  // Convert the ISO date string to a moment object and then to Persian date
  const persianDate = moment(isoDateString, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
    .locale('fa')
    .format('YYYY/MM/DD');

  // Convert to local time (without seconds)
  // const timeWithoutSeconds = moment(isoDateString).format('HH:mm');

  // Combine the Persian date and time
  return persianDate;
}

export function getPersianDateTimeV2(
  dateInput: string | Date | undefined | null,
  showToday = true,
): string | null {
  if (!dateInput) return null;

  try {
    // Convert any valid date input to a moment object
    const inputMoment = moment(dateInput);
    const now = moment();

    if (showToday && inputMoment.isSame(now, 'day')) {
      return 'امروز';
    }

    return inputMoment.format('jYYYY/jMM/jDD');
  } catch (error) {
    console.error('Error converting date:', error);
    return null;
  }
}

export function convertToPersianDate(
  isoDateString: string | undefined,
): string | null {
  if (!isoDateString) return null;
  const persianDate = moment(isoDateString, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
    .locale('fa')
    .format('jDD jMMMM jYYYY');

  return persianDate;
}

export function timeAgoPersian(dateString: string): string {
  const persianDate = moment(dateString, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').locale(
    'fa',
  );
  return persianDate.fromNow();
}

// converts 1401-1-1 to gregorian like 2024-2-3
export function jalaliToGregorian(jDate: string): string {
  return moment
    .from(jDate, 'fa', 'YYYY-MM-DD')
    .locale('en')
    .format('YYYY-MM-DD');
}

export function convertToPersianDayMonth(
  isoDateString: string | undefined,
): string {
  if (!isoDateString) return '';

  return moment(isoDateString).locale('fa').format('jDD jMMMM');
}
